/* =====================================================================
 * 自建货币转换器(替代 BEAST Currency Converter）
 * 仅做「显示转换」：把页面上以美元(USD)渲染的价格按汇率换算显示，
 * 结账仍走 Shopify 主货币 USD —— 与 BEAST 行为一致。
 *
 * 适配主题：Impulse 8（Archetype），但与主题结构基本解耦：
 * 通过识别「独立的美元价格文本节点」(如 "$49.99 USD") 来换算，
 * 不需要改主题的价格 snippet。
 *
 * 维护提示（你以后想改的地方）：
 *   - SUPPORTED：增删支持的币种、符号、显示代码。
 *   - FALLBACK_RATES：兜底汇率(仅当在线汇率源全部失败时使用)。
 *   - MARGIN：汇率加价系数(默认 0，即用中间价)。
 *   - SHOW_CODE：是否在价格后显示货币代码(对应 BEAST 的 Display Currency Code)。
 * ===================================================================== */
(function () {
  'use strict';
  if (window.__ccBooted) return;          // 防止重复加载
  window.__ccBooted = true;

  /* ------------------------- 配置 ------------------------- */
  var BASE = 'USD';                        // 店铺主货币(价格在页面上以它渲染)
  var SHOW_CODE = true;                    // 价格后是否加货币代码，如 "£39.50 GBP"
  var MARGIN = 0;                          // 汇率加价，0.02 = 在中间价上加 2%
  var RATE_TTL = 12 * 60 * 60 * 1000;      // 汇率缓存时长(12 小时)
  var STORE_KEY = 'cc_currency';           // 记住用户选择
  var RATE_KEY  = 'cc_rates_v1';           // 汇率缓存
  var GEO_KEY   = 'cc_geo_v1';             // 地区检测缓存

  // 支持的币种(基准 USD 必须在内)。flag 仅用于下拉显示，可留空。
  var SUPPORTED = {
    USD: { symbol: '$',  code: 'USD', flag: '🇺🇸', decimals: 2 },
    GBP: { symbol: '£',  code: 'GBP', flag: '🇬🇧', decimals: 2 },
    AUD: { symbol: 'A$', code: 'AUD', flag: '🇦🇺', decimals: 2 },
    CAD: { symbol: 'C$', code: 'CAD', flag: '🇨🇦', decimals: 2 },
    EUR: { symbol: '€',  code: 'EUR', flag: '🇪🇺', decimals: 2 }
  };
  var ORDER = ['USD', 'GBP', 'AUD', 'CAD', 'EUR'];

  // 兜底汇率(USD→X)，仅当所有在线汇率源失败时启用。可手动更新。
  var FALLBACK_RATES = { USD: 1, GBP: 0.79, AUD: 1.52, CAD: 1.37, EUR: 0.92 };

  // 免费、无需 key、支持 CORS 的在线汇率源(USD 基准)，按顺序尝试。
  var RATE_SOURCES = [
    { url: 'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.min.json',
      pick: function (j) { return j && j.usd; } },
    { url: 'https://latest.currency-api.pages.dev/v1/currencies/usd.min.json',
      pick: function (j) { return j && j.usd; } },
    { url: 'https://open.er-api.com/v6/latest/USD',
      pick: function (j) { return j && j.rates; } }
  ];

  // 免费、无需 key、支持 CORS 的 IP 地区源，按顺序尝试。
  var GEO_SOURCES = [
    { url: 'https://get.geojs.io/v1/ip/country.json', pick: function (j) { return j && j.country; } },
    { url: 'https://ipwho.is/',                       pick: function (j) { return j && j.country_code; } }
  ];

  // 国家(ISO2)→币种。只映射到我们支持的币种，其余默认 USD。
  var EUROZONE = 'AT BE CY EE FI FR DE GR IE IT LV LT LU MT NL PT SK SI ES AD MC SM VA ME XK'.split(' ');
  function countryToCurrency(cc) {
    if (!cc) return 'USD';
    cc = cc.toUpperCase();
    if (cc === 'GB') return 'GBP';
    if (cc === 'AU') return 'AUD';
    if (cc === 'CA') return 'CAD';
    if (EUROZONE.indexOf(cc) !== -1) return 'EUR';
    return 'USD';
  }

  /* ------------------------- 小工具 ------------------------- */
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function now() { return new Date().getTime(); }

  // 解析「独立美元价格文本」→ 数字(美元)。不是纯价格则返回 null。
  // 命中: "$49.99 USD" / "$1,234.56" / "$50" / "$0.00"。
  // 不命中: 含其它文字的句子；已转换成别的币种(£/€/A$/C$)的文本。
  var USD_RE = /^\s*\$\s?(\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)\s*(?:USD)?\s*$/;
  function parseUSD(text) {
    if (!text) return null;
    // 排除以别的币种符号开头的(A$ / C$ 也以 $ 结尾但前面有字母，已被 ^\s*\$ 排除)
    var m = USD_RE.exec(text);
    if (!m) return null;
    var n = parseFloat(m[1].replace(/,/g, ''));
    return isNaN(n) ? null : n;
  }

  // 千分位格式化
  function group(intStr) { return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  // 把美元金额按目标币种格式化为显示字符串
  function formatPrice(usd, cur) {
    var c = SUPPORTED[cur] || SUPPORTED.USD;
    var val = usd * getRate(cur) * (1 + MARGIN);
    var fixed = val.toFixed(c.decimals);
    var parts = fixed.split('.');
    var s = c.symbol + group(parts[0]) + (parts[1] ? '.' + parts[1] : '');
    if (SHOW_CODE) s += ' ' + c.code;
    return s;
  }

  /* ------------------------- 汇率 ------------------------- */
  var RATES = null;   // { USD:1, GBP:.., ... }，键为大写代码

  function normalizeRates(raw) {
    // raw 可能是 {gbp:..,aud:..}(小写) 或 {GBP:..}(大写)
    var out = { USD: 1 };
    for (var k in SUPPORTED) {
      if (k === 'USD') continue;
      var v = raw[k] != null ? raw[k] : raw[k.toLowerCase()];
      if (typeof v === 'number' && isFinite(v) && v > 0) out[k] = v;
    }
    return out;
  }

  function ratesComplete(r) {
    for (var i = 0; i < ORDER.length; i++) { if (r[ORDER[i]] == null) return false; }
    return true;
  }

  function getRate(cur) {
    if (RATES && RATES[cur] != null) return RATES[cur];
    return FALLBACK_RATES[cur] != null ? FALLBACK_RATES[cur] : 1;
  }

  function fetchJSON(url) {
    return fetch(url, { mode: 'cors', cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status); return r.json();
    });
  }

  // 依次尝试多个汇率源；成功就缓存。返回 Promise。
  function fetchRates(i) {
    i = i || 0;
    if (i >= RATE_SOURCES.length) return Promise.reject(new Error('all rate sources failed'));
    var src = RATE_SOURCES[i];
    return fetchJSON(src.url).then(function (j) {
      var raw = src.pick(j);
      if (!raw) throw new Error('bad shape');
      var r = normalizeRates(raw);
      if (!ratesComplete(r)) throw new Error('missing currency');
      return r;
    }).catch(function () { return fetchRates(i + 1); });
  }

  function loadRates() {
    var cached = lsGet(RATE_KEY);
    if (cached && cached.rates && (now() - cached.t) < RATE_TTL && ratesComplete(cached.rates)) {
      RATES = cached.rates;
      return Promise.resolve(RATES);
    }
    // 先用缓存(即使过期)或兜底顶上，避免首屏卡住
    RATES = (cached && cached.rates) ? cached.rates : Object.assign({}, FALLBACK_RATES);
    return fetchRates(0).then(function (r) {
      RATES = r;
      lsSet(RATE_KEY, { t: now(), rates: r });
      return r;
    }).catch(function () { return RATES; });
  }

  /* ------------------------- 价格扫描与替换 ------------------------- */
  // 记录已处理的价格文本节点：node -> { usd:Number }
  var nodeStore = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  var nodeList = [];   // 强引用，便于切换币种时统一重渲染；移除时清理

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, OPTION: 1, SELECT: 1, INPUT: 1 };

  function rememberNode(node, usd, orig) {
    var rec = { usd: usd, orig: orig };
    if (nodeStore) nodeStore.set(node, rec);
    node.__ccRec = rec;             // 双保险(WeakMap 不可用时)
    if (nodeList.indexOf(node) === -1) nodeList.push(node);
  }
  function nodeRec(node) {
    if (nodeStore && nodeStore.has(node)) return nodeStore.get(node);
    return node.__ccRec || null;
  }

  // 渲染单个已知节点为当前币种
  function renderNode(node) {
    var rec = nodeRec(node);
    if (!rec) return;
    // 选中 USD：精确还原主题原始字符串；其它币种：按汇率换算
    var txt = (CURRENT === BASE) ? rec.orig : formatPrice(rec.usd, CURRENT);
    if (node.nodeValue !== txt) node.nodeValue = txt;
    // 清理紧邻的独立 "USD" 文本节点(避免出现 "£39.50 GBP USD")
    var sib = node.nextSibling;
    if (sib && sib.nodeType === 3 && (/^\s*USD\s*$/i.test(sib.nodeValue) || sib.__ccUsdSib)) {
      sib.__ccUsdSib = sib.__ccUsdSib || sib.nodeValue;     // 记住原值
      var want = (CURRENT === BASE) ? sib.__ccUsdSib : '';
      if (sib.nodeValue !== want) sib.nodeValue = want;     // 同值不写,避免多余 mutation
    }
  }

  // 处理一个文本节点：若当前显示的是美元价格则(重新)记录并按当前币种渲染。
  // 已被换成其它币种(£/€/A$/C$)的节点不会命中 parseUSD，故不会被误改。
  function processTextNode(node) {
    var parent = node.parentNode;
    if (!parent || SKIP_TAGS[parent.nodeName]) return;
    var raw = node.nodeValue;
    if (!raw || raw.indexOf('$') === -1) return;
    var usd = parseUSD(raw);
    if (usd == null) return;
    rememberNode(node, usd, raw);   // raw 即主题渲染的原始美元串，用于还原
    renderNode(node);
  }

  // 遍历某个根节点下的所有文本节点
  function scan(root) {
    if (!root) return;
    if (root.nodeType === 3) { processTextNode(root); return; }
    if (root.nodeType !== 1) return;
    if (SKIP_TAGS[root.nodeName]) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('$') === -1) return NodeFilter.FILTER_REJECT;
        if (n.parentNode && SKIP_TAGS[n.parentNode.nodeName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n, batch = [];
    while ((n = walker.nextNode())) batch.push(n);
    for (var i = 0; i < batch.length; i++) processTextNode(batch[i]);
  }

  // 全量重渲染(切换币种时)
  function renderAll() {
    for (var i = nodeList.length - 1; i >= 0; i--) {
      var node = nodeList[i];
      if (!node.parentNode || !document.contains(node)) { nodeList.splice(i, 1); continue; }
      renderNode(node);
    }
  }

  /* ------------------------- DOM 变化监听 ------------------------- */
  var observer;
  // 判断节点是否属于本脚本注入的元素(购物车提示条/币种切换器)。
  // observer 必须忽略这些节点上的变动：否则 updateCartNotice 写入
  // textContent 会产生新 mutation → observer 回调 → 又走到这里 →
  // 微任务死循环,整页卡死。
  function isOwnNode(n) {
    for (; n; n = n.parentNode) {
      if (n.nodeType !== 1) continue;
      var cl = n.classList;
      if (cl && (cl.contains('cc-cart-notice') || cl.contains('cc-switcher'))) return true;
    }
    return false;
  }
  function startObserver() {
    if (observer || typeof MutationObserver === 'undefined') return;
    observer = new MutationObserver(function (muts) {
      var external = false;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (isOwnNode(m.target)) continue;
        external = true;
        if (m.type === 'characterData') {
          if (m.target && m.target.nodeType === 3) processTextNode(m.target);
        } else {
          for (var j = 0; j < m.addedNodes.length; j++) scan(m.addedNodes[j]);
        }
      }
      // 只有页面自身(非本脚本)的变动才需要刷新提示条
      if (external) updateCartNotice();
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* ------------------------- 地区自动切换 ------------------------- */
  function detectGeo() {
    var cached = lsGet(GEO_KEY);
    if (cached && cached.cur) return Promise.resolve(cached.cur);
    return tryGeo(0).then(function (cc) {
      var cur = countryToCurrency(cc);
      lsSet(GEO_KEY, { cur: cur, cc: cc || '', t: now() });
      return cur;
    }).catch(function () {
      // 兜底：用浏览器语言粗略判断
      var lang = (navigator.language || '').toUpperCase();
      var cur = 'USD';
      if (/\-GB$/.test(lang)) cur = 'GBP';
      else if (/\-AU$/.test(lang)) cur = 'AUD';
      else if (/\-CA$/.test(lang)) cur = 'CAD';
      else if (/(\-(DE|FR|IT|ES|NL|IE|AT|BE|PT|FI|GR))$/.test(lang)) cur = 'EUR';
      lsSet(GEO_KEY, { cur: cur, cc: '', t: now() });
      return cur;
    });
  }
  function tryGeo(i) {
    if (i >= GEO_SOURCES.length) return Promise.reject(new Error('geo failed'));
    var src = GEO_SOURCES[i];
    return fetchJSON(src.url).then(function (j) {
      var cc = src.pick(j);
      if (!cc) throw new Error('no country');
      return cc;
    }).catch(function () { return tryGeo(i + 1); });
  }

  /* ------------------------- 切换器 UI ------------------------- */
  var CURRENT = 'USD';

  function buildSwitcher() {
    var wrap = document.createElement('div');
    wrap.className = 'cc-switcher';
    var sel = document.createElement('select');
    sel.className = 'cc-switcher__select';
    sel.setAttribute('aria-label', 'Currency');
    for (var i = 0; i < ORDER.length; i++) {
      var code = ORDER[i], c = SUPPORTED[code];
      var opt = document.createElement('option');
      opt.value = code;
      opt.textContent = (c.flag ? c.flag + ' ' : '') + code + ' ' + c.symbol;
      sel.appendChild(opt);
    }
    sel.value = CURRENT;
    sel.addEventListener('change', function () { setCurrency(sel.value, true); });
    wrap.appendChild(sel);
    return wrap;
  }

  function injectSwitcher() {
    if (document.querySelector('.cc-switcher')) return;
    var sw = buildSwitcher();
    // 优先放进 Impulse 页头图标区；找不到则浮动在右上角
    var host = document.querySelector(
      '.site-header__icons, .header__icons, .site-nav--icons, .header-item--icons, ' +
      '.site-header__icon-wrapper, [data-header-wrapper] .site-nav'
    );
    if (host) {
      sw.classList.add('cc-switcher--inline');
      host.insertBefore(sw, host.firstChild);
    } else {
      sw.classList.add('cc-switcher--float');
      document.body.appendChild(sw);
    }
  }

  function injectStyles() {
    if (document.getElementById('cc-styles')) return;
    var css = ''
      + '.cc-switcher{display:inline-flex;align-items:center;}'
      + '.cc-switcher__select{font:inherit;color:inherit;background:transparent;border:1px solid currentColor;'
      + 'border-radius:4px;padding:4px 8px;cursor:pointer;line-height:1.2;opacity:.9;}'
      + '.cc-switcher__select:hover{opacity:1;}'
      + '.cc-switcher--inline{margin:0 10px;}'
      + '.cc-switcher--float{position:fixed;top:12px;right:12px;z-index:9999;background:#fff;'
      + 'border-radius:6px;box-shadow:0 2px 10px rgba(0,0,0,.15);padding:4px 6px;}'
      + '.cc-switcher--float .cc-switcher__select{color:#222;border-color:#ccc;}'
      + '.cc-cart-notice{font-size:.85em;opacity:.8;margin:8px 0;line-height:1.4;}';
    var st = document.createElement('style');
    st.id = 'cc-styles';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function syncSwitcher() {
    var sel = document.querySelector('.cc-switcher__select');
    if (sel && sel.value !== CURRENT) sel.value = CURRENT;
  }

  /* ------------------------- 购物车提示 ------------------------- */
  function updateCartNotice() {
    // 只放在购物车页脚区域(抽屉车/购物车页),不放商品表单，避免重复与污染 PDP
    var hosts = document.querySelectorAll(
      '.cart__footer, .drawer__footer, .cart-drawer__footer, .ajaxcart__footer, [data-cart-footer]'
    );
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var note = host.querySelector('.cc-cart-notice');
      if (CURRENT === 'USD') { if (note) note.style.display = 'none'; continue; }
      var msg = 'All orders are processed in USD. Your cart is shown in ' + CURRENT
              + '; you will be charged in USD at checkout.';
      if (!note) {
        note = document.createElement('div');
        note.className = 'cc-cart-notice';
        host.insertBefore(note, host.firstChild);
      }
      note.style.display = '';
      // 同值不写：给 textContent 赋相同字符串也会换掉文本节点、触发 mutation
      if (note.textContent !== msg) note.textContent = msg;
    }
  }

  /* ------------------------- 切换币种 ------------------------- */
  function setCurrency(cur, manual) {
    if (!SUPPORTED[cur]) cur = 'USD';
    CURRENT = cur;
    if (manual) lsSet(STORE_KEY, { cur: cur });
    renderAll();
    syncSwitcher();
    updateCartNotice();
  }

  /* ------------------------- 初始化 ------------------------- */
  function decideInitialCurrency() {
    var saved = lsGet(STORE_KEY);
    if (saved && saved.cur && SUPPORTED[saved.cur]) return Promise.resolve(saved.cur);
    return detectGeo();   // 首访按地区
  }

  function boot() {
    injectStyles();
    injectSwitcher();
    startObserver();
    // 先扫描一遍当前页面(此时多为 USD，先建立基准映射)
    scan(document.body);
    loadRates().then(function () {
      return decideInitialCurrency();
    }).then(function (cur) {
      setCurrency(cur, false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // 暴露给控制台手动调试：CC.set('GBP') / CC.rates()
  window.CC = {
    set: function (c) { setCurrency(c, true); },
    rates: function () { return RATES; },
    current: function () { return CURRENT; }
  };
})();
